import styled from "styled-components";
import React from "react";
import { PlanetProps } from "Data/planet";

import { useIsListClicked } from "Provider/HomeProvider";

interface ThreeProps {
	data: PlanetProps[];
	setNowId: React.Dispatch<React.SetStateAction<string>>;
	setHoverId: React.Dispatch<React.SetStateAction<string>>;
	canvasRef: React.RefObject<HTMLDivElement>;
}

const Wrapper = styled.div<{ active: boolean }>`
	height: 100vh;
	height: ${(props) => props.theme.layout.full_height};
	width: 100%;
	transition: ${(props) => props.theme.transition.default};
	opacity: ${(props) => (props.active ? 1 : 0)};
	display: block;
	overflow: hidden;
	position: absolute;
	z-index: ${(props) => props.theme.zIndex.canvas};
	canvas {
		outline: none;
	}
`;
const ThreeWrapper: React.FC<ThreeProps> = ({ canvasRef }) => {
	const { isListClicked } = useIsListClicked();

	return <Wrapper ref={canvasRef} active={!isListClicked}></Wrapper>;
};

export default ThreeWrapper;
